'use client'

import { CheckCircle2, Loader2 } from 'lucide-react'
import { type LucideIcon } from 'lucide-react'
import * as React from 'react'

import { Button, type ButtonProps } from './button'

interface LoadingButtonProps extends ButtonProps {
  /** Show a loading spinner and disable the button */
  loading?: boolean
  /** Icon to show before children (hidden during loading/success) */
  icon?: LucideIcon
  /** When true, show CheckCircle2 + successLabel instead of normal content */
  success?: boolean
  /** Label shown during success state (default: "Saved!") */
  successLabel?: string
}

const LoadingButton = React.forwardRef<HTMLButtonElement, LoadingButtonProps>(
  ({ loading, icon: Icon, success, successLabel = 'Saved!', disabled, children, ...props }, ref) => {
    return (
      <Button ref={ref} disabled={disabled || loading} {...props}>
        {loading ? (
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
        ) : success ? (
          <CheckCircle2 className="mr-2 h-4 w-4 text-success-foreground" />
        ) : Icon ? (
          <Icon className="mr-2 h-4 w-4" />
        ) : null}
        {success ? successLabel : children}
      </Button>
    )
  },
)
LoadingButton.displayName = 'LoadingButton'

export { LoadingButton, type LoadingButtonProps }
